import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { BrowseCourse } from '@udemy-v2/browse-course';
import { Tag } from '@udemy-v2/react-product-card-components';
import { BrowseCourseCard } from '@udemy-v2/react-browse-course';
import { useContentLengthFormatter } from '@/features/course-landing-page/hooks/use-content-length-formatter.react-component';
import { useFormatNumber, LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import { Ribbon } from '@udemy-v2/react-notice-components';
import { Icon } from '@udemy-v2/icons';
import { StarRating } from '@udemy-v2/react-merchandising-components';
import styles from './condensed-browse-course-card.module.scss';
import classNames from 'classnames';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
interface CondensedBrowseCourseCardProps {
  course: BrowseCourse;
}
export const NumLearnersRibbon = t0 => {
  const $ = _c(9);
  const {
    count,
    className
  } = t0;
  const {
    formatNumber
  } = useFormatNumber();
  let t1;
  if ($[0] !== count || $[1] !== formatNumber) {
    t1 = formatNumber(count);
    $[0] = count;
    $[1] = formatNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedCount = t1;
  let t2;
  if ($[3] !== className) {
    t2 = classNames(styles.gray_ribbon, className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon color="inherit" size="xsmall" glyph="people" label={false} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formattedCount || $[7] !== t2) {
    t4 = <Ribbon className={t2}>{t3}{formattedCount}</Ribbon>;
    $[6] = formattedCount;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export const RatingRibbon = t0 => {
  const $ = _c(7);
  const {
    rating,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.gray_ribbon, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rating) {
    t2 = <StarRating numeric={true} rating={rating} size="small" />;
    $[2] = rating;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Ribbon className={t1}>{t2}</Ribbon>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const CondensedBrowseCourseCard = t0 => {
  const $ = _c(19);
  const {
    course
  } = t0;
  const formatContentLength = useContentLengthFormatter();
  const {
    gettext,
    locale,
    interpolate
  } = useI18n();
  const hasOrganization = useUserHasOrganization();
  const t1 = locale || "en_US";
  let t2;
  if ($[0] !== course.updatedOn || $[1] !== t1) {
    const userLocale = t1.replace("_", "-");
    t2 = new Date(course.updatedOn || "").toLocaleDateString(userLocale, {
      year: "numeric",
      month: "numeric"
    });
    $[0] = course.updatedOn;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const lastUpdatedDate = t2;
  const lengthInMinutes = (course.durationInSeconds || 0) / 60;
  let t3;
  if ($[3] !== formatContentLength || $[4] !== lengthInMinutes) {
    t3 = formatContentLength(lengthInMinutes);
    $[3] = formatContentLength;
    $[4] = lengthInMinutes;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const formattedLength = t3;
  let t4;
  if ($[6] !== hasOrganization) {
    t4 = {
      hideDescription: true,
      openInNewTab: true,
      hidePrice: hasOrganization
    };
    $[6] = hasOrganization;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== course.enrollments || $[9] !== course.rating || $[10] !== formattedLength || $[11] !== gettext || $[12] !== interpolate || $[13] !== lastUpdatedDate) {
    t5 = () => [...(course.rating?.average ? [<RatingRibbon key="rating" rating={course.rating.average} />] : []), ...(course.enrollments?.count ? [<NumLearnersRibbon key="num-learners" count={course.enrollments.count} />] : []), <Tag key="content-length">{formattedLength}</Tag>, <Tag key="last-updated-date"><LocalizedHtml html={interpolate(gettext("<span>Updated: %(date)s</span>"), {
        date: lastUpdatedDate
      }, true)} interpolate={{
        date: <span>{lastUpdatedDate}</span>
      }} /></Tag>];
    $[8] = course.enrollments;
    $[9] = course.rating;
    $[10] = formattedLength;
    $[11] = gettext;
    $[12] = interpolate;
    $[13] = lastUpdatedDate;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== course || $[16] !== t4 || $[17] !== t5) {
    t6 = <BrowseCourseCard course={course} layout="condensed" options={t4} renderAuthors={_temp} renderTags={t5} />;
    $[15] = course;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
function _temp() {
  return null;
}